import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";
import { api } from "../lib/api";

function formatDate(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return "";
  }
}

export default function NewsGrid({ limit }) {
  const [news, setNews] = useState([]);

  useEffect(() => {
    api.get("/news").then((r) => setNews(r.data)).catch(() => {});
  }, []);

  const shown = limit ? news.slice(0, limit) : news;

  return (
    <section
      id="noticias"
      data-testid="news-section"
      className="py-24 md:py-32 bg-[#FAF9F6] border-t border-neutral-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-14 items-end">
          <div className="lg:col-span-7">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#003F88] font-semibold">
              <span className="accent-line" />
              Notícias & atualizações
            </div>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight mt-6 text-neutral-900">
              O dia a dia <em className="italic font-light">do mandato</em>.
            </h2>
          </div>
          {limit && (
            <Link
              to="/noticias"
              data-testid="news-cta-all"
              className="lg:col-span-5 lg:justify-self-end inline-flex items-center gap-3 text-sm uppercase tracking-[0.2em] font-medium text-[#003F88]"
            >
              Ver todas as notícias <ArrowRight size={16} />
            </Link>
          )}
        </div>

        {shown.length === 0 ? (
          <div className="text-center py-16 text-neutral-500" data-testid="news-empty">
            Em breve, novas atualizações.
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-neutral-200">
            {shown.map((n, idx) => (
              <Link
                key={n.id}
                to={`/noticias/${n.slug}`}
                data-testid={`news-card-${n.slug}`}
                className="group bg-white p-6 md:p-8 flex flex-col reveal hover:bg-neutral-50 transition-colors"
                style={{ animationDelay: `${idx * 0.06}s` }}
              >
                {n.cover_image && (
                  <div className="overflow-hidden mb-6 -mx-6 -mt-6 md:-mx-8 md:-mt-8">
                    <img
                      src={n.cover_image}
                      alt={n.title}
                      className="editorial-img w-full h-56 object-cover group-hover:scale-[1.02] transition-transform duration-500"
                    />
                  </div>
                )}
                <div className="flex items-center gap-4 text-[11px] uppercase tracking-widest text-neutral-500">
                  <span className="text-[#003F88] font-semibold">{n.category}</span>
                  <span className="inline-flex items-center gap-1.5">
                    <Calendar size={12} /> {formatDate(n.created_at)}
                  </span>
                </div>
                <h3 className="font-serif-display text-2xl md:text-[26px] font-medium leading-tight mt-4 text-neutral-900 group-hover:text-[#003F88] transition-colors">
                  {n.title}
                </h3>
                <p className="mt-3 text-sm md:text-base text-neutral-600 font-light leading-relaxed">
                  {n.excerpt}
                </p>
                <div className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[#003F88]">
                  Ler matéria <ArrowRight size={14} />
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
